<template>
  <div>
    <h4>Products Filter</h4>
    <el-card>
      <el-form-item label="Brand">
        <el-checkbox v-model="checkBrandAll">ALL</el-checkbox>
        <el-checkbox-group v-model="checkedBrands" v-show="!checkBrandAll" size="mini">
          <el-checkbox-button v-for="item in brands" :label="item" :key="item.id">{{item.name}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Category">
        <el-checkbox v-model="checkCategoryAll">ALL</el-checkbox>
        <el-checkbox-group v-model="checkedCategories" v-show="!checkCategoryAll" size="mini">
          <el-checkbox-button
            v-for="item in categories"
            :label="item"
            :key="item.value"
          >{{item.label}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Designated" v-if="showProductDesignate">
        <el-checkbox v-model="checkProductAll">ALL</el-checkbox>
        <transition name="fade">
        <div v-show="!checkProductAll">
          <div>
            <el-button size="mini" type="primary" @click="addNewProductLine">+ Add Line</el-button>
            <el-button
              size="mini"
              type="warning"
              plain
              :disabled="!lineSelected"
              @click="handleDelete"
            >Delete Line</el-button>
          </div>
          <el-table
            ref="multipleTable"
            :row-style="{height:'36px'}"
            :style="{width:'596px'}"
            border
            stripe
            size="small"
            :header-cell-style="{background:'#D7D7D7',color:'#000'}"
            @selection-change="handleSelectionChange"
            :data="products"
            :row-key="(row)=>row.id"
          >
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column type="index" width="45" align="center"></el-table-column>
            <el-table-column label="Item Code" width="200">
              <template v-slot="scope">
                <ColumnProductCodeSelectPopper :rowId="scope.row.id" source="report" />
              </template>
            </el-table-column>
            <el-table-column label="Item Name" width="300">
              <template v-slot="scope">
                <ColumnProductNameInput :rowId="scope.row.id" source="report" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        </transition>
      </el-form-item>
    </el-card>
  </div>
</template>
<script>
import ColumnProductCodeSelectPopper from './ColumnProductCodeSelectPopper'
import ColumnProductNameInput from './ColumnProductNameInput'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ReportProducts',
  components: {
    ColumnProductCodeSelectPopper,
    ColumnProductNameInput
  },
  props: {
    showProductDesignate: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('report', [
      'productAll',
      'products',
      'brandAll',
      'selectedBrands',
      'categoryAll',
      'selectedCategories'
    ]),
    ...mapState(['categories', 'brands']),
    checkBrandAll: {
      get () {
        return this.brandAll
      },
      set (val) {
        this.setBrandAll(val)
      }
    },
    checkedBrands: {
      get () {
        return this.selectedBrands
      },
      set (val) {
        this.setBrands(val)
      }
    },
    checkCategoryAll: {
      get () {
        return this.categoryAll
      },
      set (val) {
        this.setCategoryAll(val)
      }
    },
    checkedCategories: {
      get () {
        return this.selectedCategories
      },
      set (val) {
        this.setCategories(val)
      }
    },
    checkProductAll: {
      get () {
        return this.productAll
      },
      set (val) {
        this.setProductAll(val)
      }
    }
  },
  data () {
    return {
      lineSelected: false
    }
  },
  methods: {
    ...mapMutations({
      setProductAll: 'report/setProductAll',
      addNewProductLine: 'report/addNewProductLine',
      deleteProduct: 'report/deleteProduct',

      setBrands: 'report/setBrands',
      setBrandAll: 'report/setBrandAll',
      setCategories: 'report/setCategories',
      setCategoryAll: 'report/setCategoryAll'
    }),
    handleDelete () {
      const ids = this.$refs.multipleTable.selection.map(sel => sel.id)
      if (ids.length === 0) {
        return
      }

      ids.forEach(i => this.deleteProduct(i))
    },
    handleSelectionChange (selection) {
      this.lineSelected = selection.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>
